import DOMPurify from 'dompurify';
import { HTMLSection } from '@/types';

interface HTMLRendererProps {
  section: HTMLSection;
}

export function HTMLRenderer({ section }: HTMLRendererProps) {
  // Sanitize HTML to prevent XSS attacks
  const sanitizedHTML = DOMPurify.sanitize(section.data.content, {
    ALLOWED_TAGS: [
      'div', 'span', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
      'ul', 'ol', 'li', 'a', 'strong', 'em', 'br', 'hr',
      'table', 'thead', 'tbody', 'tr', 'th', 'td',
      'blockquote', 'code', 'pre', 'img',
    ],
    ALLOWED_ATTR: ['class', 'id', 'href', 'src', 'alt', 'title', 'style'],
    ALLOW_DATA_ATTR: false,
  });

  return (
    <div className="p-6 bg-card border border-border rounded-lg">
      <div
        className="prose prose-slate dark:prose-invert max-w-none"
        dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
      />
    </div>
  );
}
